<template>
  <div>
    <div class="ui equal width grid">
      <div class="column" v-for="(link, index) in links" :key="index">
        <a @click="go(link)"
          ><div class="ui button">{{ link.name }}</div></a
        >
      </div>
    </div>
    <request-modal
      v-if="show_request_modal"
      @close="show_request_modal = false"
      :configuration="configuration"
      ref="request_modal"
      v-on:succedded="succedded"
    />
  </div>

  <!-- <generic-container
    icon="list"
    :title="$t('requested nvidia codes')"
    v-bind:show_plus="true"
    v-on:add="add"
    :show_refresh="true"
    @refresh="refresh_data"
  >
    <div class="ui segment">
      <div class="ui two column grid">
        <div class="column">
          <h4 class="ui dividing header">{{ $t("active bundles") }}</h4>
        </div>
        <div class="column">
          <h4 class="ui dividing header">{{ $t("new bundles") }}</h4>
        </div>
      </div>
    </div>
    <div class="ui segment">
      <h4 class="ui dividing header">{{ $t("bundle details") }}</h4>
      <table
        class="ui blue very compact celled striped selectable table"
        ref="table"
        style="width:100%"
      >
        <thead>
          <tr>
            <th>{{ $t("date") }}</th>
            <th>{{ $t("serie") }}</th>
            <th>{{ $t("gpu") }}</th>
            <th>{{ $t("product") }}</th>
            <th>{{ $t("brand") }}</th>
            <th>{{ $t("bill") }}</th>
          </tr>
        </thead>
        <tbody></tbody>
      </table>
    </div>
    <request-modal
      v-if="show_request_modal"
      @close="show_request_modal = false"
      :configuration="configuration"
      ref="request_modal"
      v-on:succedded="succedded"
    />
  </generic-container> -->
</template>

<script>
import filters from "@/filters";
import {
  local_api,
  error_toast,
  // init_json_local_data_datables,
  // enterprise_setup,
} from "@/utils";
// import GenericContainer from "@/components/GenericContainer";
import ConfigureModal from "./configuration_modal/Index.vue";
import RequestModal from "./request_modal/Index";

// @ is an alias to /src
export default {
  name: "NvidiaTicketIndex",
  components: {
    // "generic-container": GenericContainer,
    RequestModal,
  },
  filters: filters,
  data() {
    return {
      configure_modal: ConfigureModal,
      show_request_modal: false,
      configuration: undefined,
      links: [
        { name: "store", route: "NworkforceStore" },
        { name: "nvidia 1", route: "NworkforceNvidia1" },
      ],
    };
  },
  methods: {
    succedded() {
      // this.refresh_data();
    },
    add() {
      this.show_request_modal = true;
    },
    refresh_data() {
      this.get_configuration();
    },
    get_configuration() {
      let vm = this;
      // let ent_setup = enterprise_setup(vm);
      local_api(vm, "post", "/nvidia_ticket/ticket/do-get-configuration")
        .then((config) => {
          vm.configuration = config;
        })
        .catch((err) => {
          error_toast(err);
        });
    },
    go(link) {
      this.$router.push({
        name: link.route,
      });
    },
  },
  created() {},
  mounted() {
    let vm = this;

    vm.get_configuration();
  },
  watch: {},
};
</script>
